import styles from "./styles.module.scss";
import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";

import { PopconfirmProps } from "./types";
import { MergedColumnType } from "../table/utils/types";
import { TranslationContext } from "../../../contexts/translation/index.context";
import { ModalContext } from "../../../contexts/modal/index.context";
import { SessionContext } from "../../../contexts/session/index.context";
import { request } from "../../../services";
//UI
import Button from "antd/lib/button";
import Popconfirm from "antd/lib/popconfirm";
import message from "antd/lib/message";
//Icons
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";

import checkBefore from '../../../helpers/selectionOfActions';
import Tooltip from "antd/lib/tooltip";



export default function PopconfirmComponent(props: PopconfirmProps) {
  const [loading, setLoading] = useState(false);
  const { setRefresh } = useContext(ModalContext);
  const { intl } = useContext(TranslationContext);
  const { sessionData } = useContext(SessionContext);
  const { setRefreshFileEditor } = useContext(ModalContext);
  const location = useLocation();

  // const [popVisible, setPopVisible] = useState(false);

  const info = () => {
    message.error(intl("data-is-not-deleted"));
  };

  const handleOk = async () => {
  //Компонент перевірка на доступ до внесення даних чи змін
  let accessRights = await checkBefore(location.pathname, undefined, 'delete-file');
    if (!accessRights) {
      message.error(intl("you-do-not-have-access-rights"));
      return;
    }

    setLoading(true);
    const success = (
      await request(
        `${location.pathname.split("/").slice(0, 2).join("/")}/deletefiles`,
        {
          method: "post",
          body: {
            ids: props.filesId,
            documentId: sessionData?.bta_documents_id,
            page: location.pathname.split("/").pop(),
          },
          cancelTokenKey: "deletefiles",
        }
      )
    )?.success;
    if (!success) {
      info();
    }
    props.onSuccessDelete?.();
    setRefreshFileEditor(true);
    setLoading(false);
    // setPopVisible(false)
  };

  //   const handleCancel = () => {
  //   setPopVisible(false)
  // };

        //Компонент перевірка на доступ до внесення даних чи змін

  //   const handleDeleteClick = async () => {
  //   const { isAdm } = await checkIsAdmin(location.pathname, 'del_file');
  //   if (!isAdm) {
  //     message.error(intl("you-do-not-have-access-rights"));
  //     return;
  //   }
  //   setPopVisible(true);
  // };

  return (
    <Popconfirm
      title={intl("question-delete-entry")}
      onConfirm={handleOk}
      okButtonProps={{ loading, className: styles["popconfirm"] }}
      okText={intl("ok")}
      // visible={popVisible}
      // onCancel={handleCancel}
    >
    <Tooltip title={intl(`remove`)}>
      <Button
        // className={`${styles["button"]} ${
        //   !disabled.edit && styles["custom-button"]
        // }`}
        className={styles["button"]}
        disabled={props.disabled}
        icon={<DeleteOutlined />}
        // onClick={handleDeleteClick}
      >
        {/* {intl(props.name || "remove")} */}
      </Button>
    </Tooltip>
    </Popconfirm>
  );
}
